export default "__VITE_ASSET__BUiF768J__"